import { AfterViewInit, Component, Input, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { CtBinaryOperator, CtControlTypes, CtDatatableContainerFilterValues, CTDynamicFormGeneratorComponent, CtDynamicFormGeneratorConfiguration, CTExpansionPanelConfiguration, CtFormArrayControlOptions, CtModelConfiguration, CTModelDatatableFilter, CtModelDatatableOperators, CtModelService, CtSelectControlValue, CTSingleComponentConfiguration, CTTabConfiguration } from '@ctsolution/ct-framework';
import { CtWebapiGenericResponse } from '@ctsolution/ct-webapi';
import { CtManagerService } from 'projects/ct-manager/src/app/_core/lib/ct-manager.service';
import { CTMGeneralService } from 'projects/ct-manager/src/app/_core/lib/general.service';
import { FormTemplateRouteData } from 'projects/ct-manager/src/app/_core/route-data/form-template.route-data';
import { WorkOrderDataRouteData } from 'projects/ct-manager/src/app/_core/route-data/work-order-data.route-data';
import { CTConfigurationModel } from 'projects/ct-manager/src/app/_core/classes/ct-configuration-model';

@Component({
  selector: 'app-work-order-dynamic-form',
  templateUrl: './work-order-dynamic-form.component.html',
  styleUrls: ['./work-order-dynamic-form.component.scss']
})
export class WorkOrderDynamicFormComponent implements AfterViewInit {

  formConfigurations: Array<CtDynamicFormGeneratorConfiguration> = [];
  @Input() workOrderModelConfiguration: CtModelConfiguration<any> | null = null;
  @Input() isQuotation: boolean = false;
  @ViewChildren('formGenerator') formGeneratorComponents: QueryList<CTDynamicFormGeneratorComponent> | null = null;
  
  panelConfiguration : CTTabConfiguration | null = null;
  @ViewChild('dynamicFormTemplate') dynamicFormTemplate!: TemplateRef<any>;

  workOrderDataConfiguration = (): CtModelConfiguration<any> => CtModelConfiguration
    .create()
    .setRouteData(WorkOrderDataRouteData());

  constructor(private modelService: CtModelService<any>, private managerService : CtManagerService, private generalService : CTMGeneralService) {

  }

  async ngAfterViewInit() {

    // ✅ FIX ExpressionChangedAfterItHasBeenCheckedError
    // Ritardiamo tutto il setup con setTimeout per evitare che le assegnazioni
    // di formConfigurations e panelConfiguration avvengano durante il ciclo corrente
    setTimeout(async () => {
      await this.performSetup();
    }, 0);

  }

  private async performSetup() {

    this.setup();

    const panelConfigurationModel : CTConfigurationModel = CTConfigurationModel.create()

    await this.managerService.getComponentOverride("workOrder", "panelConfiguration", panelConfigurationModel).then((component) => {
      return;
    });

    this.panelConfiguration = CTExpansionPanelConfiguration
    .create([
      CTSingleComponentConfiguration.create(this.dynamicFormTemplate).setLabel("workOrderPanelLabel").setExpanded(panelConfigurationModel.expanded)])
      .setButtonsVisible(false);

  }

  async getValueFilterOffer(): Promise<string | null> {

    let value : string | null = null;

    const workOrderDynamicFormConfiguration : CTConfigurationModel = CTConfigurationModel.create().setVisible(false);

    await this.managerService.getComponentOverride("workOrder", "workOrderDynamicFormConfiguration", workOrderDynamicFormConfiguration).then((component) => {
      return;
    });

    if (workOrderDynamicFormConfiguration.visible) {

      value = this.isQuotation ? "QT" : "PR";

    }

    return value

  }

  getWorkOrderDynamicForms(valueCodeFilter: string | null) {

      const configuration: CtModelConfiguration<any> = CtModelConfiguration
        .create()
        .setRouteData(FormTemplateRouteData());

      const filters = CtModelDatatableOperators
        .create()
        .setFilters([
          CTModelDatatableFilter
            .create()
            .setField('Type')
            .setValue(3)
            .setOperatorType(CtBinaryOperator.Equal)
        ]);

        if(valueCodeFilter){

          const filter = CTModelDatatableFilter.create()
          .setField('Code')
          .setValue(valueCodeFilter)
          .setOperatorType(CtBinaryOperator.Equal);
          filters.Filters.push(filter);

        }

        else{

          filters.Filters.push(

            CTModelDatatableFilter
              .create()
              .setField("[Code] is null OR [Code] = ?")
              .setValue([null]) //poi andrà l'offerta qua
              .setOperatorType(CtBinaryOperator.OrOperator)
          );

        }

      return this.modelService
        .getList(configuration, filters)

    }

      getFormWorkOrderDataValue(formGeneratorOid: number): Promise<WorkOrderDynamicFormDataParameter | null> {

        return new Promise((resolve, reject) => {

          this.getWorkOrderData(formGeneratorOid)
            .subscribe((response: CtWebapiGenericResponse<CtModelConfiguration<Array<WorkOrderDynamicFormDataParameter>>>) => {

                const result = (<WorkOrderDynamicFormDataParameter[]>response.Result.DataSource ?? []);

                if (result.length) {

                  const dataSource: WorkOrderDynamicFormDataParameter = result[0];
                  resolve(dataSource);

                }

                resolve(null);

              },
              (error) => reject(error)
            );
        });

      }


      getWorkOrderData(formGeneratorOid: number) {

        const filters = CtModelDatatableOperators
          .create()
          .setFilters([
            CTModelDatatableFilter
              .create()
              .setField('WorkOrder.Oid')
              .setValue(this.workOrderModelConfiguration?.RouteData?.id)
              .setOperatorType(CtBinaryOperator.Equal),
            CTModelDatatableFilter
              .create()
              .setField('FormTemplate.Oid')
              .setValue(formGeneratorOid)
              .setOperatorType(CtBinaryOperator.Equal)
          ]);

        return this.modelService
          .getList(this.workOrderDataConfiguration(), filters);

      }


        generateWorkOrderDynamicFormDataParameter(params: { value: any, formGeneratorOid: number, workOrderOid: number }) {

          return WorkOrderDynamicFormDataParameter
            .create()
            .setContent(JSON.stringify(params.value))
            .setFormGeneratorOid(params.formGeneratorOid)
            .setWorkOrder(params.workOrderOid);

        }

  insertWorkOrderData(parameter: WorkOrderDynamicFormDataParameter) {

    const workOrderConfiguration = this.workOrderDataConfiguration();

    if (parameter.Oid) {

      workOrderConfiguration
        .RouteData
        ?.setId(parameter.Oid);

    }

    return this.modelService
      .putInfos(workOrderConfiguration, parameter);

  }

 private setChildFormData(idx: number, value: any) {

    const references = this.formGeneratorComponents?.toArray() ?? [];

    const componentRef = references[idx];
    
    
    if (componentRef) {

      componentRef
        .form
        .patchValue(value);

      componentRef
        .formConfiguration
        ?.controls
        ?.filter(items => items.type === CtControlTypes.FORMARRAY)
        .forEach(formArray => {

          const options = formArray.options as CtFormArrayControlOptions;

          if (!options) return;

          options
            .notifyValuesUpdated(value[formArray.name!]);

        })

      componentRef
        .formConfiguration
        ?.controls
        ?.filter(items => items.type === CtControlTypes.LOOKUP)
        .forEach(lookup => {

          const valueLookup = value[lookup.name!];

          
          // Se il valore non è un primitivo (es. già un CtSelectControlValue) non re-idratiamo
          if (valueLookup === null || valueLookup === undefined || typeof valueLookup === 'object') return;

          const lookupInfos = (lookup as any).LookupInfos;
          const endpointConfig = (lookup as any).remoteValueOptionsEndpoint;

          // Senza LookupInfos non sappiamo quale controller/campo usare per la re-idratazione
          if (!lookupInfos?.CodeField || !lookupInfos?.DescriptionField || !endpointConfig?.controller?.length) {

            console.warn(`[setChildFormData] Impossibile re-idratare "${lookup.name}": LookupInfos o controller mancanti.`);
            return;

          }

          // Usiamo il controller dell'endpoint configurato nel JSON del form (generico, non hardcoded)
          // e filtriamo per CodeField con Equal per recuperare esattamente il record selezionato
          this.generalService.getList(
            {
              controller: endpointConfig.controller[0],
              filters: [
                CTModelDatatableFilter
                  .create()
                  .setField(lookupInfos.CodeField)
                  .setValue(valueLookup)
                  .setOperatorType(CtBinaryOperator.Equal)
              ]
            }
          ).subscribe((response: CtWebapiGenericResponse<any>) => {

            const dataSource = response?.Result?.DataSource;

            if (!dataSource?.length) {

              console.warn(`[setChildFormData] Nessun risultato per "${lookup.name}" con valore "${valueLookup}".`);
              return;

            }

            // Leggiamo il campo descrittivo dinamicamente da DescriptionField (non hardcoded su 'Name')
            lookup
              .setValue(
                CtSelectControlValue
                  .create()
                  .setLabel(dataSource[0][lookupInfos.DescriptionField!])
                  .setValue(valueLookup));

          });

        })

    }

  }
  
   setup(): Promise<void> {

      return new Promise<void>(async (resolve, reject) => {

        this.getWorkOrderDynamicForms(null) //await this.getValueFilterOffer()
          .subscribe((response: CtWebapiGenericResponse<CtModelConfiguration<Array<any>>>) => {

            if (!response.Result.DataSource) {

              reject(new Error('Empty data source'));
              return;

            }

            (<Array<any>>response.Result.DataSource ?? [])
              .forEach(async (cnfg, idx) => {

                const dynamicFormConfiguration = CtDynamicFormGeneratorConfiguration
                  .create()
                  .setFormGeneratorModel(cnfg);

                let existingData = await this.getFormWorkOrderDataValue(cnfg.Oid);

                dynamicFormConfiguration
                  .setOnSubmit((filteredValue: any) => {

                    const parameter: WorkOrderDynamicFormDataParameter = this.generateWorkOrderDynamicFormDataParameter({
                      value: filteredValue.value,
                      formGeneratorOid: dynamicFormConfiguration?.formGeneratorModel?.Oid ?? -1,
                      workOrderOid: this.workOrderModelConfiguration?.RouteData?.id ?? -1
                    });

                    if (existingData?.Oid) {

                      parameter
                        .setOid(existingData.Oid)

                    }

                    this.insertWorkOrderData(parameter)
                      ?.subscribe({
                        next: (response: CtWebapiGenericResponse<number | null>) => {

                          const updatedValue = response.Result ?? existingData?.Oid ?? -1;

                          if (!existingData) existingData = {} as WorkOrderDynamicFormDataParameter
                          (<any>existingData)['Oid'] = updatedValue;

                        },
                        error: (err) => reject(err)
                      });

                  });


                this.formConfigurations
                  .push(dynamicFormConfiguration);

                if (existingData) {

                  const parsedValue = JSON.parse(existingData.Content ?? '')

                  setTimeout(() => this.setChildFormData(idx, parsedValue));

                }

              });

            resolve();

          });

      });

    }

}
export class WorkOrderDynamicFormDataParameter {

  Oid?: number | null;
  FormTemplate: { Oid: number; } | null = null;
  WorkOrder: { Oid: number; } | null = null;
  Content: string | null = null;

  public constructor() {
  }

  public static create = () => new WorkOrderDynamicFormDataParameter();

  setOid(value: number) {

    this.Oid = value;
    return this;

  }

  setContent(value: string) {

    this.Content = value;
    return this;

  }

  setFormGeneratorOid(value: number) {

    this.FormTemplate = {
      Oid: value
    };
    return this;

  }

  setWorkOrder(value: number) {

    this.WorkOrder = {
      Oid: value
    };
    return this;

  }

}
